// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let IconV5 = require("./IconV5.bs.js");
let IconButton = require("./IconButton.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function classesForVariant(secondary, type_) {
  if (secondary) {
    if (type_ === "error") {
      return "border border-tan-error-500 bg-tan-error-500/10 text-tan-error-700";
    } else if (type_ === "warning") {
      return "border border-tan-warning bg-tan-warning/10 text-tan-warning";
    } else if (type_ === "success") {
      return "border border-tan-success bg-tan-success/10 text-tan-success-dark";
    } else {
      return "border border-tan-blue-500 bg-tan-blue-500/10 text-tan-blue-500";
    }
  } else if (type_ === "error") {
    return "bg-tan-error-500 text-white";
  } else if (type_ === "warning") {
    return "bg-tan-warning text-white";
  } else if (type_ === "success") {
    return "bg-tan-success text-white";
  } else {
    return "bg-tan-blue-500 text-white";
  }
}

function iconOfMessageType(x) {
  if (x === "error") {
    return "attention";
  } else {
    return "tick";
  }
}

function renderButtons(id, dismissible, handleOnDismiss, children) {
  let onDismiss = Stdlib_Option.getOr(handleOnDismiss, param => {});
  if (Stdlib_Option.isSome(children) || dismissible) {
    return JsxRuntime.jsxs("div", {
      children: [
        children !== undefined ? JsxRuntime.jsx("div", {
            children: children,
            className: "flex flex-row"
          }) : null,
        dismissible ? JsxRuntime.jsx(IconButton.make, {
            icon: "cancel",
            onPress: () => onDismiss(id),
            title: "Dismiss",
            className: "border-0 bg-transparent text-inherit hover:text-inherit hover:bg-black/5 min-w-10 min-h-10"
          }) : null
      ],
      className: TailwindMerge.twMerge([
        "flex flex-row items-center gap-4 shrink-0",
        Stdlib_Option.isSome(children) ? "w-full justify-end md:w-auto" : ""
      ])
    });
  } else {
    return null;
  }
}

function SystemMessage(props) {
  let children = props.children;
  let handleOnDismiss = props.handleOnDismiss;
  let __icon = props.icon;
  let __secondary = props.secondary;
  let __dismissible = props.dismissible;
  let type_ = props.type_;
  let __time = props.time;
  let id = props.id;
  let time = __time !== undefined ? __time : 3000;
  let dismissible = __dismissible !== undefined ? __dismissible : false;
  let secondary = __secondary !== undefined ? __secondary : false;
  let icon = __icon !== undefined ? __icon : false;
  let className = secondary ? "text-base font-semibold py-2" : "text-lg font-light py-2.5";
  let styleClassName = classesForVariant(secondary, type_);
  let classNames = TailwindMerge.twMerge([
    className,
    styleClassName
  ]);
  React.useEffect(() => {
    if (handleOnDismiss === undefined) {
      return;
    }
    if (time <= 0) {
      return;
    }
    let timeout = setTimeout(() => handleOnDismiss(id), time);
    return () => {
      clearTimeout(timeout);
    };
  }, [time]);
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            icon ? JsxRuntime.jsx(IconV5.make, {
                icon: iconOfMessageType(type_),
                className: "mr-4 relative top-0.5 inline align-baseline"
              }) : null,
            JsxRuntime.jsx("span", {
              children: props.text,
              className: "block sm:inline w-full sm:w-auto leading-5"
            })
          ],
          className: "leading-5 flex flex-row flex-1 min-w-0"
        }),
        renderButtons(id, dismissible, handleOnDismiss, children)
      ],
      className: TailwindMerge.twMerge([
        "w-full mx-auto flex flex-row items-center justify-between gap-4",
        Stdlib_Option.isSome(children) ? "flex-col items-start md:flex-row md:items-center" : "",
        "px-4",
        secondary ? "px-2.5" : "",
        "max-w-[720px] md:max-w-[960px] xl:max-w-[1140px] 2xl:max-w-[1320px]"
      ])
    }),
    className: classNames
  });
}

let make = SystemMessage;

exports.make = make;
/* react Not a pure module */
